// extracted by mini-css-extract-plugin
export var actions = "_19-0";
export var actionsContainer = "_19-7";
export var border = "_19-1";
export var childFullHeight = "_19-e";
export var collapse = "_19-2";
export var content = "_19-9";
export var contentChild = "_19-d";
export var fullscreen = "_19-b";
export var hasLeftRadius = "_19-q";
export var headerContainer = "_19-3";
export var headerRow = "_19-5";
export var hidePadding = "_19-a";
export var navCollapsedGap = "_19-r";
export var noScrollX = "_19-s";
export var noScrollY = "_19-t";
export var noTopPadding = "_19-o";
export var optOutTopPadding = "_19-c";
export var outletContent = "_19-k";
export var outletContentInner = "_19-l";
export var outletLeadingPanel = "_19-h";
export var outletLeadingPanelAttention = "_19-i";
export var outletResizeDivider = "_19-j";
export var outletSplit = "_19-f";
export var outletSplitResizing = "_19-g";
export var pageMain = "_19-p";
export var pageOuter = "_19-m";
export var pagePadding = "_19-8";
export var profile = "_19-u";
export var profileContainer = "_19-v";
export var profileImage = "_19-w";
export var profileMain = "_19-x";
export var profileSubtitle = "_19-z";
export var profileTitle = "_19-y";
export var showLeftPadding = "_19-n";
export var tabsPortalSlot = "_19-6";
export var tabsWrapper = "_19-4";
export var title = "_19-10";